//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import exclusiveDest from '@/components/operation/exclusiveDest'
import exclusiveProgress from '@/components/operation/exclusiveProgress'
import axios from 'axios';
import FileSaver from "file-saver";
import wxConfig from '@/assets/js/wx_config'

export default {
    name: "Exclusive",
    components: {
        exclusiveDest,
        exclusiveProgress,
        bgDiv:new Object(),
        bgImg:new Object(),
    },
    data(){
        return {
            progress:0,
            regT:'注册立享相册制作',
            regV:'199元',
            downloadFlag:true,
            spuType:this.$route.query.spuType,
            shareType:this.$route.query.shareType
        }
    },
    created(){
        this.$store.commit('UPDATE_HEAD',false);
        this.$store.commit('UPDATE_FOOTER',false);
        this.$store.commit('UPDATE_PAGE_TITLE','新人专享');
        document.title = '新人专享'
        if(this.spuType === undefined){
            this.spuType = '1'
        }
        
    },
    mounted(){
        this.bgDiv = document.getElementById("bgDiv");
        this.bgImg = document.getElementById("bgImg");

        if(wxConfig.isWeiXin()){
            if(this.shareType === undefined){
                let title = "给孩子的童年留下一本相册，金秋十月促销中！"
                let desc = "别再去影楼花好几千啦~，李诗慧亲自设计，将孩子的照片融入到这个温馨梦幻的有爱世界皮面、优雅大方，专业设计师为您服务，别再去影楼花好几千啦~"
                let linkUrl = "http://mobile.mianhuain.com/#/exclusive?spuType=" + this.spuType
                let imgUrl = "http://cdn.matl.binstar.vip/image/spuLogo.jpg?x-oss-process=style/thumbnail_hd";
                wxConfig.wxConfigBuild_in(title,desc,linkUrl,imgUrl);
            }else{
                let title = "把时光宛入相册，金秋十月促销中！"
                let desc = "1V1设计师为您服务，精美皮面、优雅大方，别再去影楼花好几千啦~"
                let linkUrl = "http://mobile.mianhuain.com/#/exclusive?spuType=" + this.spuType + "&shareType=" + this.shareType
                let imgUrl = "http://cdn.matl.binstar.vip/image/spuLogo.jpg?x-oss-process=style/thumbnail_hd";
                wxConfig.wxConfigBuild_in(title,desc,linkUrl,imgUrl); 
            }
            
        }
    },
    methods:{
        checkIsAppleDevice(){
            let u = navigator.userAgent, app = navigator.appVersion;
            let ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
            let iPad = u.indexOf('iPad') > -1;
            let iPhone = u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1;
            if (ios || iPad || iPhone) {
                return true;
            } else {
                return false;
            }
        },
        downloadApp(){
            let self = this
            if (this.checkIsAppleDevice()) {
                window.location.href = "https://apps.apple.com/cn/app/%E6%A3%89%E8%8A%B1in/id1533577677"
            }else{
                if(wxConfig.isWeiXin()){
                    this.bgDiv.style.display="flex";
                    this.bgImg.style.display="flex";
                }else{
                    window.location.href = "http://cdn.matl.binstar.vip/appVersion/mhi.apk?t=" + new Date().getTime()
                }
            } 
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/operation/Exclusive.vue